import React, { type ReactElement } from 'react';
import { useDfContext } from '../context/df-context';
import { SET_FILTER_PARAMS } from '../context/actions';
import { useFilterlabel } from '../hooks/use-filterlabel';
import FilterMultiSelectDropdown from './filter-multi-select-dropdown';
import { getTranslation } from '../utils/config';

export default function FilterPillAttributes({
  isProductPage,
}: {
  isProductPage?: boolean;
}): ReactElement {
  const { state, dispatch } = useDfContext();
  const { itemFilter, availableFilters } = state;

  const { langLabel, fileLabel } = useFilterlabel();
  const variantLabel = getTranslation('variants');

  const handleChangeSelection = (filterType: string) => (selectedValues: string[]) => {
    dispatch({
      type: SET_FILTER_PARAMS,
      filter: {
        ...itemFilter,
        [filterType]: selectedValues,
      },
    });
  };

  const handleResetFilter = (filterType: string) => () => {
    dispatch({
      type: SET_FILTER_PARAMS,
      filter: {
        ...itemFilter,
        [filterType]: [],
      },
    });
  };

  const languages = availableFilters?.dfAttributeDfLanguage;
  const fileTypes = availableFilters?.dfAttributeDfFileType;
  const variants = availableFilters?.variants;

  const hasLanguages = languages && Object.keys(languages)?.length > 0;
  const hasFileTypes = fileTypes && Object.keys(fileTypes)?.length > 0;
  const hasVariants = isProductPage && variants && Object.keys(variants)?.length > 0;
  const showFilterBar = hasVariants || hasFileTypes || hasLanguages;

  return (
    (showFilterBar && (
      <nav className="df_filter-compact filter-compact__right">
        {hasVariants && (
          <FilterMultiSelectDropdown
            label={variantLabel || ''}
            handleChangeSelection={handleChangeSelection('variants')}
            handleResetFilter={handleResetFilter('variants')}
            values={variants}
            selectedValues={itemFilter?.variants}
            filterName="variant"
          />
        )}
        {hasLanguages && (
          <FilterMultiSelectDropdown
            label={langLabel || ''}
            handleChangeSelection={handleChangeSelection('language')}
            handleResetFilter={handleResetFilter('language')}
            values={languages}
            selectedValues={itemFilter?.language}
            filterName="languages"
          />
        )}
        {hasFileTypes && (
          <FilterMultiSelectDropdown
            label={fileLabel || ''}
            handleChangeSelection={handleChangeSelection('fileType')}
            handleResetFilter={handleResetFilter('fileType')}
            values={fileTypes}
            selectedValues={itemFilter?.fileType}
            filterName="filetypes"
          />
        )}
      </nav>
    )) || <></>
  );
}
